<template>
  <a-card title="Empleado" bodyStyle="padding: 0px;" :bordered="false">
    <a-descriptions :column="1" bordered>
      <a-descriptions-item label="RUT">
        {{ displayValue(employee?.rut) }}
      </a-descriptions-item>
      <a-descriptions-item label="Primer nombre">
        {{ displayValue(employee?.firstName) }}
      </a-descriptions-item>
      <a-descriptions-item label="Segundo nombre">
        {{ displayValue(employee?.secondName) }}
      </a-descriptions-item>
      <a-descriptions-item label="Primer apellido">
        {{ displayValue(employee?.firstSurname) }}
      </a-descriptions-item>
      <a-descriptions-item label="Segundo apellido">
        {{ displayValue(employee?.secondSurname) }}
      </a-descriptions-item>
      <a-descriptions-item label="Fecha de nacimiento">
        {{
          formatDateOnly(
            employee?.birthdayDate ??
              employee?.birthDate ??
              movement?.birthdayDate
          )
        }}
      </a-descriptions-item>
      <a-descriptions-item label="Email">
        {{ displayValue(employee?.email) }}
      </a-descriptions-item>
      <a-descriptions-item label="Grupo">
        {{ displayValue(employee?.groups) }}
      </a-descriptions-item>
      <a-descriptions-item label="Centro de costo">
        {{ displayValue(employee?.costCenter ?? movement?.costCenter) }}
      </a-descriptions-item>
      <a-descriptions-item label="Tipo de contrato">
        {{
          displayValue(
            employee?.contractType ??
              movement?.contractType ??
              employee?.tipoCont ??
              movement?.tipoCont
          )
        }}
      </a-descriptions-item>
      <a-descriptions-item label="Renta">
        {{ displayValue(employee?.incomeAmount) }}
      </a-descriptions-item>
    </a-descriptions>
  </a-card>
</template>

<script setup>
import { defineProps } from 'vue';

const displayValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

const formatDateOnly = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('es-CL', { timeZone: 'UTC' });
};

defineProps({
  employee: {
    type: Object,
    default: () => ({})
  },
  movement: {
    type: Object,
    default: () => ({})
  }
});
</script>
